import { invokeApi } from "../../../../bl_libs/ApiCalling";
import MaterialTable from "material-table";
import React, { useState, useEffect } from "react";
import { forwardRef } from "react";
import Radio from "@material-ui/core/Radio";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ListRequest from "./ListRequest";
import CancelRequest from "./CancelRequest";
import { getStatusForCustomer } from "../../../../ui_libs/Functions/functions";
///-------dialog-transition-------///
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
///-----------------CSS-Classes---------------///
const useStyles = makeStyles({
  hed: {
    fontWeight: "bold",
  },
  clmwdth: {
    width: "10px",
  },
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  btnadd: {
    float: "right",
    margin: 10,
  },
  tabbtn: {
    margin: 10,
  },
});

function DoneRequest(props) {
  console.log(props, "propsssss");
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [del, setDel] = React.useState(false);
  const [addQuestion, setAddQuestion] = React.useState(false);
  const [selectedrow, setrowdata] = React.useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [clicked, setclicked] = useState("1");
  let [data, setData] = useState([]);
  ///---------------------Functions-------------------///

  const handleClose = () => {
    setDel(false);
    setAddQuestion(false);
    setOpen(false);
  };

  const getcustomername = (rowdata) => {
    return `${rowdata.customer_profile.first_name} ${rowdata.customer_profile.last_name}`;
  };

  const handleAgreeClose = () => {};
  const activehandle = () => {
    setclicked("0");
  };
  const canclehandle = () => {
    setclicked("2");
  };
  const donehandle = () => {
    setclicked("1");
  };
  const FetchRequestList = () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    const Data = {
      type: "1",
    };
    console.log(Data);
    let requestObj = {
      path: "/api/admin/list_request",
      method: "POST",
      postData: Data,
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      props.setCounts({
        ...props.counts,
        active:res.request_count.active_request_count,
        cancel:res.request_count.cancle_request_count,
        done:res.request_count.done_request_count,
      })
      console.log(res, "RESPONSE");
      setIsLoading(false);
      setData(res.request_list);
    });
  };
  useEffect(() => {
    FetchRequestList();
    console.log(data, "dataaa");
  }, []);

  const [columns, setColumns] = useState([
    {
      title: <span className={classes.hed}>#</span>,
      width: 150,
      render: (rowData) => <>{rowData.tableData.id + 1}</>,
    },
    {
      title: <span className={classes.hed}>Rquest Id</span>,
      field: "request.id",
      sorting: false,
    },
    {
      title: <span className={classes.hed}>Schedule Time</span>,
      field: "request.schedule_time",
      sorting: false,
    },
    {
      title: <span className={classes.hed}>Net Distance</span>,
      field: "request.net_distance",
      render: (rowData) => rowData.request.net_distance + " mi",
      sorting: false,
    },
    {
      title: <span className={classes.hed}>Final Amount</span>,
      field: "request.final_amount",
      render: (rowData) =>
        rowData.request.final_amount
          ? "$ " + rowData.request.final_amount
          : "N/A",
      sorting: false,
    },
    {
      title: <span className={classes.hed}>Customer Name</span>,
      render: (rowData) => <>{getcustomername(rowData)}</>,
      sorting: false,
    },
    {
      title: <span className={classes.hed}>Company Name</span>,
      field: "company_profile.name",
      sorting: false,
    },
    {
      title: <span className={classes.hed}>Request Type</span>,
      render: (rowData) =>
        rowData.request.request_type ? "CRM" : "Market Place",
      sorting: false,
    },
    {
      title: (
        <span className={classes.hed + " text-center"}>Request Status</span>
      ),
      render: (rowData) => (
        <>
          <div className="request-staus small-font-size">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="8" r="8" fill="#C4314B"></circle>
            </svg>{" "}
            <span className="pl-2">
              {getStatusForCustomer(
                rowData.request.request_timeline_status,
                rowData.request.request_type,
                rowData.request.additional_status
              )}
            </span>
          </div>
        </>
      ),
      sorting: false,
    },
    {
      title: <span className={classes.hed}>Request Detail</span>,
      render: (rowData) => (
        <Button
          onClick={() => {
            props.history.push({
              pathname: "/admin/request/details/" + rowData.request.id,
            });
          }}
          variant="outlined"
          color="primary"
        >
          Detail
        </Button>
      ),
      sorting: false,
    },
  ]);
  ///-------------styling-icons---------------------///

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => (
      <Edit className={classes.Icons} {...props} ref={ref} />
    )),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    DeleteIcon: forwardRef((props, ref) => <DeleteIcon {...props} ref={ref} />),
  };

  if (isLoading) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  } else if (clicked == "0") {
    return <ListRequest></ListRequest>;
  } else if (clicked == "2") {
    return <CancelRequest></CancelRequest>;
  }
  return (
    <>
      <MaterialTable
        title="Done Requests"
        // Fixed hanging problem on ReRendering
        columns={columns.map((c) => ({ ...c, tableData: undefined }))}
        data={data}
        icons={tableIcons}
        options={{
          actionsColumnIndex: -1,
          search: true,
          searchFieldAlignment: "right",
          searchFieldVariant: "standard",
          pageSize: 25,
          pageSizeOptions: [25, 50, 100, 200],
          emptyRowsWhenPaging: false,
          headerStyle: {
            backgroundColor: "#c4314b",
            color: "white",
            fontWeight: "bold",
          },
        }}
      />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{`Are you sure you want to Delete Service no ${selectedrow.id} ?`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {selectedrow.zip_code}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Disagree
          </Button>
          <Button onClick={handleAgreeClose} color="primary">
            Agree
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={del}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{`Something get wrong!`}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={addQuestion}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{}</DialogTitle>(
        <div className="Circular-Progress">
          <CircularProgress color="primary" />
        </div>
        )
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default withRouter(DoneRequest);
